import React from 'react'
import { useSelector } from 'react-redux'

import { LiveUserAction } from 'components/set/Chat/LiveUserAction/LiveUserAction'
import { getLUAs } from 'redux/slices/liveUserActions'
import useStyles from './styles'
import clsx from 'clsx'

const LuaContainer = ({ horizontal = false, travelDistance }) => {
    const classes = useStyles()
    const luas = useSelector(getLUAs)

    return (
        <div
            className={clsx(classes.luaAnchor, horizontal && classes.horizontal)}
            id="lua-container"
            onAnimationEnd={e => {
                e.target.classList.add('lua-idle')
            }}
        >
            {luas.map(lua => (
                <LiveUserAction key={lua.id} lua={lua} horizontal={horizontal} travelDistance={travelDistance} />
            ))}
        </div>
    )
}

export default LuaContainer
